module.exports = __webpack_public_path__ + "img/ida_lowres.f47345ba.png";